import React from 'react'

type AlertTriangleIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const AlertTriangleIcon = ({
  width = 20,
  height = 20,
  className,
  color = 'currentColor',
}: AlertTriangleIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10 14.1667H10.0083M10 7.5V10.8333M8.575 3.21667L1.51667 15C1.37114 15.252 1.29414 15.5377 1.29332 15.8288C1.29251 16.1198 1.36791 16.4059 1.51202 16.6588C1.65614 16.9116 1.86394 17.1223 2.11476 17.2699C2.36558 17.4175 2.65067 17.4968 2.94167 17.5H17.0583C17.3493 17.4968 17.6344 17.4175 17.8852 17.2699C18.1361 17.1223 18.3439 16.9116 18.488 16.6588C18.6321 16.4059 18.7075 16.1198 18.7067 15.8288C18.7059 15.5377 18.6289 15.252 18.4833 15L11.425 3.21667C11.2764 2.97176 11.0673 2.76927 10.8177 2.62874C10.5681 2.48821 10.2864 2.41438 10 2.41438C9.71355 2.41438 9.43194 2.48821 9.18234 2.62874C8.93273 2.76927 8.72356 2.97176 8.575 3.21667Z"
      stroke={color}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
